.page {
  width: 100%;
}

.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: var(--space-8);
  flex-wrap: wrap;
  gap: var(--space-4);
}

.title {
  font-family: var(--font-heading);
  font-size: 28px;
  font-weight: 400;
  color: var(--color-text);
  letter-spacing: -0.01em;
}

.subtitle {
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--color-text-dim);
  margin-top: var(--space-1);
}

@media (min-width: 768px) {
  .title {
    font-size: 36px;
  }
}

/* Toolbar */
.toolbar {
  margin-bottom: var(--space-6);
}

.toolbarLeft {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

@media (min-width: 640px) {
  .toolbarLeft {
    flex-direction: row;
    align-items: center;
  }
}

.searchWrapper {
  position: relative;
  flex: 1;
  max-width: 360px;
}

.searchIcon {
  position: absolute;
  left: var(--space-3);
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: var(--color-text-muted);
  pointer-events: none;
}

.searchInput {
  width: 100%;
  padding: var(--space-2) var(--space-3) var(--space-2) var(--space-10);
  font-family: var(--font-body);
  font-size: 13px;
  color: var(--color-text);
  background: var(--color-bg-input);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
}

.searchInput:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(90, 166, 66, 0.2);
}

.searchInput::placeholder {
  color: var(--color-text-muted);
}

.toolbarRight {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  margin-top: var(--space-4);
}

@media (min-width: 640px) {
  .toolbarRight {
    margin-top: 0;
    justify-content: flex-end;
  }
}

.filterGroup {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.filterLabel {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-text-dim);
  white-space: nowrap;
}

.filterSelect {
  padding: var(--space-2) var(--space-8) var(--space-2) var(--space-3);
  font-family: var(--font-body);
  font-size: 12px;
  color: var(--color-text);
  background: var(--color-bg-input);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right var(--space-3) center;
  transition: all var(--transition-fast);
}

.filterSelect:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(90, 166, 66, 0.2);
}

.sortDirBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: var(--color-text-dim);
  background: var(--color-bg-input);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.sortDirBtn:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.sortDirBtn.desc .sortIcon {
  transform: rotate(180deg);
}

.sortIcon {
  width: 16px;
  height: 16px;
  transition: transform var(--transition-fast);
}

/* Grid */
.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-4);
}

@media (min-width: 480px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 768px) {
  .grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.playerCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  text-decoration: none;
  padding: var(--space-5);
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  transition: all var(--transition-base);
}

.playerCard:hover {
  border-color: var(--color-primary);
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg), var(--shadow-glow-primary);
}

.playerHead {
  position: relative;
  margin-bottom: var(--space-3);
}

.onlineIndicator {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 14px;
  height: 14px;
  background: var(--color-online);
  border: 2px solid var(--color-bg-panel);
  border-radius: 50%;
  box-shadow: 0 0 8px var(--color-online);
  animation: pulse 2s ease-in-out infinite;
}

.playerInfo {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.playerNameRow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.playerName {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 14px;
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}

.playerMeta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-1);
  font-family: var(--font-body);
  font-size: 11px;
  color: var(--color-text-muted);
}

.lastSeen.online {
  color: var(--color-online);
  font-weight: 700;
}

/* Empty State */
.emptyState {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-16) var(--space-6);
  text-align: center;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  color: var(--color-text-dim);
}

.emptyIcon {
  width: 64px;
  height: 64px;
  color: var(--color-text-muted);
  margin-bottom: var(--space-4);
  opacity: 0.5;
}

.emptyState h3 {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 400;
  color: var(--color-text);
  margin-bottom: var(--space-2);
}

.emptyState p {
  font-family: var(--font-body);
  font-size: 13px;
}

/* Pagination */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
  margin-top: var(--space-10);
  flex-wrap: wrap;
}

.pageNumbers {
  display: flex;
  align-items: center;
  gap: var(--space-1);
}

.pageBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 0 var(--space-3);
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 13px;
  color: var(--color-text);
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.pageBtn:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
}

.pageBtn.active {
  color: var(--color-text-inverse);
  background: var(--color-primary);
  border-color: var(--color-primary);
  box-shadow: var(--shadow-sm), var(--shadow-glow-primary);
}

.ellipsis {
  color: var(--color-text-muted);
  padding: 0 var(--space-2);
}

/* Loading & Error */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-16);
  gap: var(--space-4);
  color: var(--color-text-dim);
}

.spinner {
  width: 40px;
  height: 40px;
  color: var(--color-primary);
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.errorPanel {
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
  padding: var(--space-8) var(--space-6);
}

.errorIcon {
  width: 48px;
  height: 48px;
  color: var(--color-red);
  margin: 0 auto var(--space-4);
}

.errorPanel h2 {
  font-family: var(--font-heading);
  font-size: 20px;
  font-weight: 400;
  color: var(--color-text);
  margin-bottom: var(--space-2);
}

.errorPanel p {
  font-family: var(--font-body);
  font-size: 13px;
  color: var(--color-text-dim);
  margin-bottom: var(--space-6);
}

/* Tabs in toolbar */
.toolbar :global(.mc-tabs) {
  border: 1px solid var(--color-border);
  background: var(--color-bg-input);
}

.toolbar :global(.mc-tab) {
  font-size: 11px;
  min-width: 80px;
}

.toolbar :global(.mc-tab.active) {
  font-size: 11px;
}